export const summaryHeaderColumn = [
  {headerName: 'Hisab / Voucher Number', exportHead: 'Hisab / Voucher Number',field: 'HisabNo', xlCol: { dataType: 'string', dataFormatter: null }, align: 'left', },
  { headerName: 'Hisab / Voucher Date', exportHead: 'Hisab / Voucher Date', field: 'HisabDate', xlCol: { dataType: 'string', dataFormatter: null }, align: 'left' },
  {headerName: 'Hisab / Voucher Amount', exportHead: 'Hisab / Voucher Amount',field: 'Amount', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right', },
  { headerName: 'Commission in %', exportHead: 'Commission in %', field: 'Comm', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right' },
  {headerName: 'Generated By', exportHead: 'Generated By',field: 'GeneratedBy', xlCol: { dataType: 'string', dataFormatter: null }, align: 'left', },
]
export const detailedSubHeading = [
  {headerName: 'LR No.', exportHead: 'LR No.',field: 'LRNo', xlCol: { dataType: 'string', dataFormatter: null }, align: 'left', },
  { headerName: 'Challan No.', exportHead: 'Challan No.', field: 'ChallanNo', xlCol: { dataType: 'string', dataFormatter: null }, align: 'left' },
  {headerName: 'To Station', exportHead: 'To Station',field: 'ToStation', xlCol: { dataType: 'string', dataFormatter: null }, align: 'left', },
  { headerName: 'No. of Parcel/Cover', exportHead: 'No. of Parcel/Cover', field: 'Items', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right' },
  {headerName: 'Remarks', exportHead: 'Remarks',field: 'Remarks', xlCol: { dataType: 'string', dataFormatter: null }, align: 'left', },
  {headerName: 'Amount', exportHead: 'Amount',field: 'Freight', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right', },
]
export const IsHeadingData=[
    { value: `Vehicle No.: GJ-01-AB-1111`, colSpan: 2, align: 'left' },
    { value: `Hisab / Voucher No: 1065`, colSpan: 2, align: 'left' },
    { value: `Hisab / Voucher Date: 21-Oct-23`, colSpan: 2, align: 'right' },
    {IsHeading:true}
  ]

  // export const detailedSubHeading={
  //   LrNo:"LR No.",
  //   ChalNo:"Challan No.",
  //   Station:"To Station",
  //   Parcel:"No. of Parcel/Cover",
  //   Remarks:"Remarks",
  //   Amount:"Amount",
  //   isSubHeading:true
  // }
